// extracted by css-extract-rspack-plugin
export default {"card":"weIe5","table":"tVRlJ","row":"G9wxg","action":"tLsua","rowEditor":"AaxRQ","input":"C_dHb"};